import React, { forwardRef } from 'react';
import { Input, DatePicker, TimePicker } from 'antd';

const DateTimeField = forwardRef(({ value, onChange }, ref) => {
  const triggerChange = (changedValue) => {
    if (typeof onChange === 'function') {
      onChange({
        ...value,
        ...changedValue,
      });
    }
  };

  return (
    <Input.Group compact>
      <DatePicker
        value={value.date}
        onChange={(date) => triggerChange({ date })}
        allowClear={false}
        format="DD.MM.YYYY"
      />
      <TimePicker
        value={value.time}
        onChange={(time) => triggerChange({ time })}
        allowClear={false}
        minuteStep={15}
        format="HH:mm"
      />
    </Input.Group>
  );
});

export default DateTimeField;
